import {BreadcrumbClickedEvent} from "./events";
import {EventBus} from "../../../../common/ts/events/EventBus";
import tracking from "../../../../common/ts/core/tracking";
import {WhitelabelEvent} from "../../../../common/ts/events/Events";

let eventBus: EventBus

export function breadcrumbClickedEventHandler(event: WhitelabelEvent) {
    const {payload: {level}} = (event as BreadcrumbClickedEvent);
    eventBus.emit(new tracking.TrackAnalyticsEvent({
            name: `serp-breadcrumb-link-level-${level}`
        })
    )
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(BreadcrumbClickedEvent.TYPE, breadcrumbClickedEventHandler);
}

export default {
    init
}